import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import { useSelector } from 'react-redux';
import { selectUserHasFileManagerDeleteScope, selectIsUngatedForPermissions } from '../selectors/Auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  linkProps: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  trackInteraction: PropTypes.func
};
const FilesTrashLink = ({
  linkProps
}) => {
  const isUngatedForPermissions = useSelector(selectIsUngatedForPermissions);
  const hasFileManagerDeleteScope = useSelector(selectUserHasFileManagerDeleteScope);
  if (isUngatedForPermissions && hasFileManagerDeleteScope || !isUngatedForPermissions) {
    return /*#__PURE__*/_jsxs(UILink, Object.assign({}, linkProps, {
      href: `/files-trash/${PortalIdParser.get()}?sourceUrl=${encodeURIComponent(window.location.toString())}`,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "delete"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.filesTrash.link"
      })]
    }));
  }
  return null;
};
FilesTrashLink.propTypes = propTypes;
export default FilesTrashLink;